import { render } from "./default-admin.vue?vue&type=template&id=8778b21e&scoped=true"
import script from "./default-admin.vue?vue&type=script&lang=js"
export * from "./default-admin.vue?vue&type=script&lang=js"

import "./default-admin.vue?vue&type=style&index=0&id=8778b21e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8778b21e"]])

export default __exports__